import standardAPI from '@/api/standard_items';

const state = {
  team: [],
  team_status: '',
  team_MetaData: {},
  team_page: 1,
  team_perPage: 10,
};

const responseUrl = '/team';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_team ({ commit }, getOptions) {
    commit('TEAM_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl + '/manage',
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        if (response && response.data) {
          commit('TEAM_SUCCESS', response);
          commit('TEAM_READY');
          resolve(response);
        } else {
          commit('TEAM_ERROR');
          reject(response);
        }
      }, preparedOptions);
    });
  },
  add_team_item ({ commit, dispatch }, itemData) {
    commit('TEAM_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('TEAM_READY');
          reject(response);
        }
      });
    });
  },
  edit_team_item ({ commit, dispatch }, itemData) {
    commit('TEAM_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('TEAM_READY');
          reject(response);
        }
      });
    });
  },
  remove_team_item ({ commit, dispatch }, itemData) {
    commit('TEAM_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('TEAM_READY');
          reject(response);
        }
      });
    });
  },
  reorder_team_item ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.team_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.team_perPage = max;
  },
  TEAM_READY: (state) => {
    state.team_status = 'ready';
  },
  TEAM_REQUEST: (state) => {
    state.team_status = 'loading';
  },
  TEAM_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.team_MetaData.meta = response.meta;
      state.team_MetaData.links = response.links;
    }
    state.team = response.data;
    state.team_status = 'success';
  },
  TEAM_ERROR: (state) => {
    state.team_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
